import "@babel/polyfill";
import "@babel/plugin-syntax-dynamic-import";

import "./polyfill/arrayFrom";
import "./polyfill/arrayFind";
import "./polyfill/dataset";

/* access using tab */

// ios viewport
const appHeight = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}
window.addEventListener('resize', appHeight);
appHeight();

window.mobile = (window.matchMedia("(max-width: 1024px)").matches) ? true : false;
if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    window.mobile = true;
}

const isMoble = () => {
    const current = window.mobile

    var testing = (window.matchMedia("(max-width: 1024px)").matches) ? true : false;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        testing = true;
    }

    if (testing !== current) {
        window.location.reload();
    }
}
window.addEventListener('resize', isMoble);


const tabing = (e) =>
    e.key === "Tab" && document.body.classList.add("isFocusAccess");
document.addEventListener("keydown", tabing, { once: true });
/*document.addEventListener('click', e => {
    document.removeEventListener('keydown', tabing)
    document.body.classList.remove('isFocusAccess');
}, {once: true})*/

/*
const tabing = e => e.key === 'Tab' && document.body.classList.add('isFocusAccess');
document.addEventListener('keydown', tabing)
document.addEventListener('click', e => {
    document.body.classList.remove('isFocusAccess');
})
*/

/* tooltip */
import tooltip from "./modules/tooltip";
new tooltip({
    onopen(sel) {
        if (window.innerXidth < 768) {
            const els_focusable = sel.querySelectorAll("input,button,a");
            els_focusable && els_focusable[0].focus();
        }
    },
});

/* darkmode */
const cookie = {
    create(name, value, days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        document.cookie = `${name}=${value}${days ? `; expires=${date.toGMTString()}` : ""
            }; path=/`;
    },
    read(name) {
        const nameEQ = `${name}=`;
        for (let item of document.cookie.split(";")) {
            while (item.charAt(0) === " ")
                item = item.substring(1, item.length);
            if (item.indexOf(nameEQ) === 0)
                return item.substring(nameEQ.length, item.length);
        }
        return null;
    },
    erase(name) {
        var hostname = document.location.hostname;
        if (hostname.indexOf("www.") === 0) hostname = hostname.substring(4);
        document.cookie = `${name}=; domain=.${hostname}; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=`;
        document.cookie = `${name}=; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/`;
    },
    eraseUnused() {
        for (let checkbox of checkboxes) {
            !checkbox.checked &&
                checkbox.dataset.cookies
                    .split(",")
                    .forEach((val) => cookie.erase(val));
        }
    },
};
const checkbox_darkmode = document.querySelector("#checkbox-darkmode");
const checkbox_contrastmode = document.querySelector("#checkbox-contrastmode");
checkbox_darkmode.onchange = () => {
    if (cookie.read("is_darkmode")) {
        document.body.classList.remove("is_darkmode");
        cookie.erase("is_darkmode");
    } else {
        checkbox_contrastmode.checked = false;
        document.body.classList.add("is_darkmode");
        document.body.classList.remove("is_contrastmode");
        cookie.erase("is_contrastmode");
        cookie.create("is_darkmode", true, 30);
    }
};
checkbox_contrastmode.onchange = () => {
    if (cookie.read("is_contrastmode")) {
        document.body.classList.remove("is_contrastmode");
        cookie.erase("is_contrastmode");
    } else {
        checkbox_darkmode.checked = false;
        document.body.classList.add("is_contrastmode");
        document.body.classList.remove("is_darkmode");
        cookie.erase("is_darkmode");
        cookie.create("is_contrastmode", true, 30);
    }
};
checkbox_darkmode.checked = cookie.read("is_darkmode") ? true : false;
checkbox_contrastmode.checked = cookie.read("is_contrastmode") ? true : false;

// button to top
const btn_scrollTop = document.querySelector(".btn-toptop");
btn_scrollTop.onclick = () => {
    /* window.scrollTo({
         top: 0,
         left: 0,
         behavior: "smooth",
     });
     document.querySelector('#main').focus();*/
    window.location.href = "#main";
};
window.addEventListener(
    "scroll",
    () => {
        if (window.pageYOffset > 400) {
            btn_scrollTop.classList.add("show");
        } else {
            btn_scrollTop.classList.remove("show");
        }
    },
    { passive: true }
);

// font variant penchées
document.querySelectorAll(".variant-title").forEach((el) => {

    const regex = new RegExp(/\)\)\)([abdgopq])/gi);
    el.innerHTML = el.innerHTML.replace(
        regex,
        '<span class="is-variant">$1</span>'
    );
});

// fixed bullet nav
const nav_bullet = document.querySelector(".nav-bullet");
if (nav_bullet && window.innerWidth > 991) {
    const feature = document.querySelector(".features");
    const footer = document.querySelector(".main-footer");
    const offset = feature ? feature.offsetHeight : 0;
    let diff;
    const hasLotsOfBullets = nav_bullet.classList.contains('big') ? -40 : 0;
    // alert(hasLotsOfBullets);
    window.addEventListener("scroll", () => {
        diff = Math.floor(window.pageYOffset - footer.offsetTop + offset + (nav_bullet.offsetTop + nav_bullet.offsetHeight));
        if (diff > 0) {
            nav_bullet.style.transform = `translateY(${-diff}px)`;
        } else {
            nav_bullet.style.transform = `translateY(${hasLotsOfBullets}%)`;
        }
    });
}

// fixed quizz btn
const btnQuizz = document.querySelector("#quizz-btn");
if (btnQuizz && window.innerWidth > 991) {
    const feature = document.querySelector(".features");
    const footer = document.querySelector(".main-footer");
    const offset = feature ? feature.offsetHeight : 0;
    let diff;

    // alert(hasLotsOfBullets);

    window.addEventListener("scroll", () => {

        if (nav_bullet) {
            diff = Math.floor(window.pageYOffset - footer.offsetTop + offset + (nav_bullet.offsetTop + nav_bullet.offsetHeight));
        } else {
            diff = Math.floor(window.pageYOffset - footer.offsetTop + offset + (btnQuizz.offsetTop + btnQuizz.offsetHeight));
        }

        if (diff > 0) {
            btnQuizz.style.transform = `translateY(${-diff}px)`;
        }
    });
}

// Gestion des images complexe
function Popin(params) {
    let el;
    if (params.id) {
        el = document.getElementById(params.id);
    } else {
        el = document.createElement('div');
        el.setAttribute('role', 'dialog');
        el.setAttribute('aria-modal', true);
        el.className = `popin${params.type ? ` ${params.type}` : ''}`;
        el.innerHTML = `<button class="btn-close" type="button"></button>
		${params.type !== 'media' ? `<div class="box">${params.content}</div>` : params.content}`
        document.body.appendChild(el);
    }
    const btn_close = el.querySelector('.btn-close');
    const exec = func => typeof func === 'function' && func();

    const root = document.documentElement || window;
    const clicktouch = ('ontouchstart' in root) ? "touchstart" : "click";
    const box = el.querySelector('.box,iframe,video,img');
    const clickOut = e => {
        if (!box.contains(e.target) && !btn_close.contains(e.target)) close();
    }

    const trap = {
        btn: null,
        index: 0,
        els: [],
        isShifted: false,
        keyup(e) {
            e.key === 'Escape' && close();
            if (e.key === 'Shift') {
                trap.isShifted = false;
            }
        },
        keydown(e) {
            if (e.key === 'Shift') {
                trap.isShifted = true;
            }
            if (e.key === 'Tab') {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
                trap.isShifted ? trap.index-- : trap.index++;
                if (trap.index < 0) trap.index = trap.els.length - 1;
                if (trap.index >= trap.els.length) trap.index = 0;
                trap.els[trap.index].focus();
            }
        },
        start() {
            trap.index = 0;
            trap.btn = document.activeElement;
            trap.els = [];
            el.querySelectorAll('button,a,input').forEach((el, i) => {
                if (el.tabIndex !== null && el.tabIndex >= 0) trap.els.push(el);
                el.addEventListener('focus', () => {
                    trap.index = i;
                });
            });
            trap.els[0].focus();
            document.addEventListener('keydown', trap.keydown, false);
            document.addEventListener('keyup', trap.keyup, false);
        },
        stop() {
            trap.btn.focus();
            document.removeEventListener('keydown', trap.keydown);
            document.removeEventListener('keyup', trap.keyup);
        }
    }

    const close = () => {
        window.removeEventListener(clicktouch, clickOut);
        document.body.classList.remove('hasPopin');
        el.classList.add('close');
        trap.stop();
        el.addEventListener('animationend', e => {
            el.classList.remove('close');
            el.setAttribute('aria-hidden', true);
            exec(params.afterClose);
        }, { once: true });
        exec(params.beforeClose);
    }

    btn_close.onclick = () => close();

    el.addEventListener('animationend', () => {
        exec(params.afterOpen);
        window.addEventListener(clicktouch, clickOut);
    }, { once: true });
    document.body.classList.add('hasPopin');
    exec(params.beforeOpen);
    el.setAttribute('aria-hidden', false);
    trap.start();

    this.close = () => close();
}

const btn_popins = document.querySelectorAll('.longdesc-cta');
btn_popins.forEach(btn => btn.onclick = () =>
    new Popin({
        id: btn.getAttribute('aria-controls')
    })
);

// quick access
const quick_access = document.querySelector('.quick-access');
quick_access.querySelectorAll('a').forEach(link => {
    link.onfocus = () => quick_access.classList.add('open');
    link.onblur = () => quick_access.classList.remove('open');
});




// tracking
const tracking_linkks = document.querySelectorAll('[data-tracking-action]');
console.log(tracking_linkks);

const slugify = text =>
    text
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
        .replace(/\s+/g, '_')
        .replace(/[^\w-]+/g, '')
        .replace(/--+/g, '_');


tracking_linkks.forEach(node => {
    node.addEventListener('click', (e) => {
        if (!window.tc_events_2) { return }
        console.log("tc_events_2");
        const target = node.target;
        const href = node.href;
        const tracking_action = slugify(node.getAttribute('data-tracking-action'));
        const tracking_category = slugify(node.getAttribute('data-tracking-category'));
        const tracking_name = slugify(node.getAttribute('data-tracking-name'));

        if (!href || !tracking_action || !tracking_category || !tracking_name) { return }
        if (target !== "_blank") { e.preventDefault() }
        console.log("send");
        window.tc_events_2(
            this,
            'clic',
            {
                actionClic: tracking_action,
                categorieClic: tracking_category,
                nomClic: tracking_name
            }
        );

        if (target !== "_blank") {
            console.log("pas _blank");
            document.location = href;
        }
    })
});





import * as conditioner from "conditioner-core/conditioner-core.min";

document.documentElement.className = "js";

conditioner.addPlugin({
    // the plugin "monitor" hook
    // use in html : <div data-module="modules/component.js" data-context="@visible true"></div>
    monitor: {
        // the name of our monitor, not prefixed with "@"
        name: "visible",

        // the monitor factory method, this will create our monitor
        create: (context, element) => ({
            // current match state
            matches: false,

            // called by conditioner to start listening for changes
            addListener(change) {
                new IntersectionObserver((entries) => {
                    // update the matches state
                    this.matches = entries.pop().isIntersecting === context;

                    // inform conditioner of the new state
                    change();
                }).observe(element);
            },
        }),
    },

    // converts module aliases to paths
    moduleSetName: (name) => `./modules/${name}.js`,

    // get the module constructor
    moduleGetConstructor: (module) => module.default,

    // override the import (this makes webpack bundle all the dynamically included files as well)
    // https://webpack.js.org/api/module-methods/#import-
    // - set to "eager" to create a single chunk for all modules
    // - set to "lazy" to create a separate chunk for each module
    moduleImport: (name) => import(/* webpackMode: "lazy" */ `${name}`),
});

conditioner.hydrate(document.documentElement);
